import { RegistrationFormTicket } from "../components/RegistrationFormTicket";
import { LoggedLayout } from "../layout/LoggedLayout.tsx";


function CreateTicketFormView (){
    return (
        <div>
            <LoggedLayout>
                <RegistrationFormTicket/>
            </LoggedLayout>           
        </div>
    )
}

export {CreateTicketFormView};